package com.macrofocus.eflux.animation

import com.macrofocus.eflux.network.EFluxNode
import svgpanzoom.SvgPanZoomContext
import web.geometry.DOMPoint

class ZoomAtPointAnimation(
    private val to: EFluxNode?,
    private val svgPanZoomContext: SvgPanZoomContext,
    private val endZoom: Double,
    override val duration: Long,
    private val easing: Easing = Easing.LINEAR
) :
    AbstractAnimation() {
    private var startZoom: Double? = null
    private var end: DOMPoint? = null

    override fun start() {
        startZoom = svgPanZoomContext.getZoom()

        end = to?.svgPanZoomCenter
    }

    override fun tick(time: Long) {
        startZoom?.let { startZoom ->
            end?.let { end ->
                val normalizedTime = time.toDouble() / duration

                val currentZoom = interpolate(startZoom, endZoom, normalizedTime, easing)

    //            var projected = to.svgToScreen(currentX, currentY)

                // See https://localcoder.org/how-to-get-x-y-coordinates-from-path-element-inside-svg

    //            val sizes = svgPanZoomContext.getSizes()
    //            val viewBox = sizes.viewBox
    //            val width = viewBox.width.unsafeCast<Double>()
    //            val height = viewBox.height.unsafeCast<Double>()

    //            val panX = projected.x / width
    //            val panY = projected.y / height

                svgPanZoomContext.zoomAtPoint(currentZoom, end, true)
            }
        }
    }
}